const state = {
  AllUsers: [],
  User: {},
  NewUser: {},
  Password: {}
};

export default state;
